import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, darkBlue, blue } = colors;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  padding: 4px 0;
`;

export const FooterText = styled.p`
  font-weight: 700;
  color: ${gray01};
  font-size: 14px;
`;

export const FeaturedText = styled.a`
  color: ${darkBlue};
  text-decoration: underline;
  transition: color 0.2s ease-in;

  &:hover {
    color: ${blue};
    text-decoration: underline;
  }
`;
